import { cn } from "../../lib/utils";

export function PageHeader({ title, subtitle, right, testid }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6" data-testid={testid}>
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function Panel({ title, subtitle, right, children, className, testid }) {
  return (
    <div className={cn("bg-white border border-slate-200 rounded-lg", className)} data-testid={testid}>
      {(title || right) && (
        <div className="flex items-center justify-between px-5 pt-4 pb-3 border-b border-slate-100">
          <div>
            {title && <h3 className="font-heading text-sm font-semibold text-slate-800 tracking-tight">{title}</h3>}
            {subtitle && <p className="text-xs text-slate-400 mt-0.5">{subtitle}</p>}
          </div>
          {right}
        </div>
      )}
      <div className="p-5">{children}</div>
    </div>
  );
}

export function Stat({ label, value, sub, tone }) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4">
      <div className="text-xs text-slate-500 font-medium">{label}</div>
      <div className={cn("kpi-num text-2xl font-extrabold mt-1", tone || "text-slate-900")}>{value}</div>
      {sub && <div className="text-xs text-slate-400 mt-0.5">{sub}</div>}
    </div>
  );
}

export function Loading({ rows = 3 }) {
  return (
    <div className="space-y-3 animate-pulse">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-20 bg-slate-100 rounded-lg" />
      ))}
    </div>
  );
}

export function Empty({ text = "No data available." }) {
  return <div className="text-sm text-slate-400 py-10 text-center">{text}</div>;
}

export function Chip({ children, className }) {
  return <span className={cn("inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium", className)}>{children}</span>;
}
